export const FIELDS = {

  ID: 'id',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  ALT_NUMBER: 'altNumber',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  SKU: 'sku',
  DESCRIPTION: 'description',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  UO_MID: 'uoMId',
  UOM: 'uom',
  LEAD_FREE: 'leadFree',
  TEMP_RATING: 'tempRating',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  QUANTITY: 'quantity',
  QUANTITY_RECEIVED: 'quantityReceived',
  DUE_DATE: 'dueDate',
  SCHEDULED_SHIP_DATE: 'scheduledShipDate',
  ACTUAL_SHIP_DATE: 'actualShipDate',
  DOCK_DATE: 'dockDate',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  NAME: 'name',
  SHIPPING_DAYS: 'shippingDays',
  TRACKING_NO: 'trackingNo',
  BRING_IN: 'bringIn',
  PICK_TICKET_PRINTED: 'pickTicketPrinted',
  MESSAGE_SENT: 'messageSent',
  LOCKED: 'locked',
  CONFIRMED: 'confirmed',
  BLIND_DROP_SHIP: 'blindDropShip',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
};